import React, {useState} from 'react';
import {Link} from 'react-router-dom';
import {useProjects} from '../../ProjectsContext';
import * as style from './adminStyles';
import {Button} from "@chakra-ui/react";
import ImageManager from "./ImageManager";
import CategoryManagerCard from "../kategoriemanager/CategoryManagerCard";

export default function AdminList() {
    const {projects, deleteProject} = useProjects();
    const [error, setError] = useState('');
    const [showImageManager, setShowImageManager] = useState(false);

    const handleDelete = async (project) => {
        if (!window.confirm(`"${project.title}" wirklich löschen?`)) return;
        try {
            await deleteProject(project.id);
        } catch (err) {
            setError(err.message || 'Löschen fehlgeschlagen.');
        }
    };

    return (
        <div style={style.page}>
            <div style={style.container}>
                <div style={style.headerRow}>
                    <h1 style={style.h1}>Projekte</h1>
                    <div style={{display: 'flex', gap: '8px'}}>
                        <Link to="/" style={style.button}>Zum Universum</Link>
                        <Link to="/intern/universum" style={style.button}>Projekt Positionen ändern</Link>
                        <Link to="/intern/projekt/neu" style={style.primaryButton}>+ Neues Projekt</Link>
                        <Button onClick={() => setShowImageManager(true)} style={style.primaryButton}>
                            Bilder Verwalten
                        </Button>
                        <CategoryManagerCard />
                    </div>
                </div>

                {error && <p style={{color: '#c0392b', marginBottom: '16px'}}>{error}</p>}

                {projects.length === 0 && <p style={{color: '#777'}}>Noch keine Projekte vorhanden.</p>}

                {projects.map((project) => {
                    const thumb = project.images?.[0];
                    return (
                        <div key={project.id} style={style.rowStyle}>
                            {thumb && <img src={thumb} alt="" style={style.thumbStyleAdminList}/>}
                            <div style={{flex: 1, minWidth: 0}}>
                                <div style={{fontWeight: 600}}>{project.title}</div>
                                <div style={{fontSize: '13px', color: '#777'}}>
                                    Position: {project.position.join(', ')}
                                </div>
                            </div>
                            <Link to={`/intern/projekt/${project.id}`} style={style.button}>Bearbeiten</Link>
                            <button onClick={() => handleDelete(project)} style={style.button} aria-label="Löschen">
                                ×
                            </button>
                        </div>
                    );
                })}

                {showImageManager && (
                    <ImageManager
                        onClose={() => setShowImageManager(false)}
                    />
                )}
            </div>
        </div>
    );
}